module.exports = __webpack_public_path__ + "img/321.49e0fa53.png";